import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusNotStartedIcon = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ width: size, height: size }, rest, { stroke: 'none', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("rect", { width: '24', height: '24', rx: '4', fill: 'currentColor' }) })));
};
//# sourceMappingURL=status_not_started.icon.js.map